import React from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonLoader } from '@offerzen/pinata'

const SubmitButton = ({ className, isSubmitting = false }) => {
  return (
    <Choose>
      <When condition={isSubmitting}>
        <ButtonLoader
          size="medium"
          label="Accepting Terms"
          className={className}
        />
      </When>
      <Otherwise>
        <Button
          label="Accept Terms of Use"
          size="medium"
          type="submit"
          className={className}
        />
      </Otherwise>
    </Choose>
  )
}

SubmitButton.propTypes = {
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
}

export default SubmitButton
